import { Button, Typography } from '@/design-system';
import type { PipelineColumn as PipelineColumnDto } from '@/pages/pipelines/common/types';

import { PipelineCard } from './card';
import { PipelineDraggableCard } from './draggable-card';
import { AddCardBox, AddCardSlot, CardSlot, EmptyColumn } from './styled';

type Props = {
  column: PipelineColumnDto;
  dragAvailable: boolean;
  dragInteractionDisabled: boolean;
  onSelectCard: (_cardId: string) => void;
  onAddCard?: (_stage: string) => void;
};

export const PipelineColumnCards = ({
  column,
  dragAvailable,
  dragInteractionDisabled,
  onSelectCard,
  onAddCard,
}: Props) => {
  if (column.cards.length === 0 && !onAddCard) {
    return (
      <EmptyColumn>
        <Typography variant="body4">No cards</Typography>
      </EmptyColumn>
    );
  }

  return (
    <>
      {column.cards.map((card) =>
        dragAvailable ? (
          <PipelineDraggableCard
            key={card.id}
            card={card}
            disabled={dragInteractionDisabled || column.terminal}
            onSelect={onSelectCard}
          />
        ) : (
          <CardSlot key={card.id} data-testid="pipeline-card-slot">
            <PipelineCard card={card} onSelect={onSelectCard} />
          </CardSlot>
        ),
      )}
      {onAddCard && (
        <AddCardSlot data-testid="pipeline-add-card-slot">
          <AddCardBox>
            <Button
              color="tertiary"
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => onAddCard(column.stage)}
            >
              Add card
            </Button>
          </AddCardBox>
        </AddCardSlot>
      )}
    </>
  );
};
